(function () {
  'use strict';

  if (window.__llCartCleanupLoaded) return;
  window.__llCartCleanupLoaded = true;

  var checkoutSanitizeInProgress = false;

  function cloneProperties(properties) {
    var out = {};
    if (!properties) return out;
    Object.keys(properties).forEach(function (key) {
      var value = properties[key];
      if (value == null || value === '') return;
      out[key] = String(value);
    });
    return out;
  }

  function cleanText(value) {
    return String(value == null ? '' : value).replace(/^\s+|\s+$/g, '');
  }

  function firstValue(properties, keys) {
    for (var i = 0; i < keys.length; i += 1) {
      var value = properties && properties[keys[i]];
      if (value != null && String(value) !== '') return String(value);
    }
    return '';
  }

  function yesOnly(value) {
    return String(value || '').toLowerCase() === 'yes' ? 'Yes' : '';
  }

  function toDownloadUrl(value) {
    var raw = String(value || '');
    if (!/^https?:\/\//i.test(raw)) return raw;

    try {
      var parsed = new URL(raw, window.location.href);
      parsed.searchParams.set('download', '1');
      return parsed.toString();
    } catch (error) {
      return raw + (raw.indexOf('?') === -1 ? '?' : '&') + 'download=1';
    }
  }

  function toInlineImageUrl(value) {
    var raw = String(value || '');
    if (!raw) return raw;
    try {
      var parsed = new URL(raw, window.location.href);
      parsed.searchParams.delete('download');
      return parsed.toString();
    } catch (error) {
      return raw.replace(/([?&])download=1(?:&|$)/, '$1').replace(/[?&]$/, '');
    }
  }

  function isLlTechnicalProperty(key) {
    return [
      '_customization_id',
      '_addon_for',
      '_addon_type',
      '_addon_name',
      '_parent_customization_id',
      '_parent_variant_id',
      '_accessory_customization_id',
      '_Original Photo URL',
      '_Preview Image',
      '_Edited Preview URL',
      '_pplr_preview',
      '_Accessory Original Photo URL',
      '_Accessory Preview Image',
      '_Accessory Edited Preview URL',
      '_accessory_pplr_preview',
      '_ll_cloudflare_worker',
      '_ll_editor_status',
      '_ll_editor_version',
      '_ll_shape',
      '_ll_crop_data',
      '_ll_rotation_deg',
      '_ll_zoom_percent',
      '_ll_accessory_cloudflare_worker',
      '_ll_accessory_editor_status',
      '_ll_accessory_editor_version',
      '_ll_accessory_shape',
      '_ll_accessory_crop_data',
      '_ll_accessory_rotation_deg',
      '_ll_accessory_zoom_percent',
      '_ll_selected_size_price',
      '_ll_configurator_total',
      '_ll_addon_total',
      '_Crystal Shape',
      '_Crystal Size',
      '_Text Engraving',
      '_Light Base'
    ].indexOf(key) !== -1;
  }

  function isLlCartItem(item) {
    var properties = (item && item.properties) || {};
    return Object.keys(properties).some(isLlTechnicalProperty) ||
      Boolean(properties['_Original Photo'] || properties['_Edited Image']);
  }

  function buildCrystalProperties(item) {
    var source = cloneProperties(item.properties);
    var out = {};

    var shape = firstValue(source, ['_Crystal Shape', 'Crystal Shape', '_ll_shape', '_Shape']);
    var size = firstValue(source, ['_Crystal Size', 'Crystal Size', '_Size']);
    var original = firstValue(source, ['_Original Photo URL', '_Original Photo', '_ll_original_photo_url']);
    var edited = firstValue(source, ['_Preview Image', '_Edited Preview URL', '_pplr_preview', 'Edited Photo', '_Edited Image', '_ll_edited_photo_url', '_ll_preview_photo_url']);
    var engraving = cleanText(firstValue(source, ['Engraving Text']));

    if (shape) out['_Shape'] = shape;
    if (size) out['_Size'] = size;
    if (original) out['_Original Photo'] = toDownloadUrl(original);
    if (edited) out['_Edited Image'] = toDownloadUrl(edited);
    if (engraving) out['Engraving Text'] = engraving;

    var keepBackground = yesOnly(firstValue(source, ['_Keep Background', 'Keep Background']));
    var ultraHd = yesOnly(firstValue(source, ['_Ultra HD Engraving', 'Ultra HD Engraving']));
    var giftWrapping = yesOnly(firstValue(source, ['_Gift Wrapping', 'Gift Wrapping']));

    if (keepBackground) out['_Keep Background'] = keepBackground;
    if (ultraHd) out['_Ultra HD Engraving'] = ultraHd;
    if (giftWrapping) out['_Gift Wrapping'] = giftWrapping;

    return out;
  }

  function buildAccessoryProperties(item) {
    var source = cloneProperties(item.properties);
    var out = {};
    var original = firstValue(source, ['_Accessory Original Photo URL', '_Original Photo URL', '_Original Photo']);
    var edited = firstValue(source, ['_Accessory Preview Image', '_Preview Image', '_Edited Preview URL', '_pplr_preview', '_Edited Image']);

    if (original) out['_Original Photo'] = toDownloadUrl(original);
    if (edited) out['_Edited Image'] = toDownloadUrl(edited);
    return out;
  }

  function buildCheckoutProperties(item) {
    var source = cloneProperties(item.properties);
    var addonType = String(source['_addon_type'] || '').toLowerCase();

    if (addonType === 'customized_accessory') {
      return buildAccessoryProperties(item);
    }

    if (addonType === 'service' || addonType === 'lightbase') {
      return {};
    }

    if (isLlCartItem(item)) {
      return buildCrystalProperties(item);
    }

    // Unrelated store products keep their own line-item properties untouched.
    return source;
  }

  function needsCheckoutSanitization(cart) {
    return Boolean(cart && Array.isArray(cart.items) && cart.items.some(function (item) {
      var properties = item.properties || {};
      return Object.keys(properties).some(isLlTechnicalProperty);
    }));
  }

  function cartItemToAddPayload(item) {
    var payload = {
      id: item.variant_id,
      quantity: item.quantity,
      properties: buildCheckoutProperties(item)
    };

    var sellingPlan = item && item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
    if (sellingPlan && sellingPlan.id) payload.selling_plan = sellingPlan.id;
    return payload;
  }

  function fetchJson(url, options) {
    return fetch(url, options).then(function (response) {
      if (!response.ok) {
        return response.text().then(function (text) {
          throw new Error(text || ('Request failed: ' + response.status));
        });
      }
      return response.json();
    });
  }

  function sanitizeCartForCheckout() {
    return fetchJson('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (cart) {
      if (!needsCheckoutSanitization(cart)) return cart;

      var items = cart.items.map(cartItemToAddPayload);
      var note = cart.note || '';
      var attributes = cart.attributes || {};

      return fetchJson('/cart/clear.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({})
      }).then(function () {
        return fetchJson('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items: items })
        });
      }).then(function () {
        return fetchJson('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ note: note, attributes: attributes })
        });
      });
    });
  }

  function isCheckoutTrigger(target) {
    if (!target || !target.closest) return false;
    return Boolean(target.closest(
      'a[href="/checkout"], a[href^="/checkout?"], a[href*="/checkout"], button[name="checkout"], input[name="checkout"], [data-ll-checkout]'
    ));
  }

  document.addEventListener('click', function (event) {
    if (!isCheckoutTrigger(event.target)) return;
    if (checkoutSanitizeInProgress) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    checkoutSanitizeInProgress = true;
    document.documentElement.classList.add('ll-checkout-preparing');

    sanitizeCartForCheckout()
      .then(function () {
        window.location.assign('/checkout');
      })
      .catch(function (error) {
        checkoutSanitizeInProgress = false;
        document.documentElement.classList.remove('ll-checkout-preparing');
        console.error('[3D Laser Land] Could not prepare clean checkout data.', error);
        window.alert('We could not prepare your customized order for checkout. Please try again.');
      });
  }, true);

  window.llCartDisplayProperties = function (properties) {
    var out = {};
    if (!properties) return out;
    Object.keys(properties).forEach(function (key) {
      var value = properties[key];
      if (!value || key.charAt(0) === '_') return;
      if (/^https?:\/\//.test(String(value))) {
        out[key] = '<a href="' + String(value).replace(/"/g, '&quot;') + '" target="_blank" rel="noopener">View image</a>';
      } else {
        out[key] = value;
      }
    });
    return out;
  };

  window.llCartPreviewImage = function (cartItem, fallback) {
    if (!cartItem || !cartItem.properties) return fallback;
    var props = cartItem.properties;
    var image = props['_Edited Image'] || props['_Preview Image'] || props['_Edited Preview URL'] || props['_pplr_preview'] || props['Edited Photo'] || props['_ll_edited_photo_url'] || props['_ll_original_photo_url'];
    return image ? toInlineImageUrl(image) : fallback;
  };
})();
